<template>
	<li >
		<div class="hoverable">
			<div
				:class="{bold: isFolder, notBold: !isFolder}"
				@click="toggle">
				<template v-if="isFolder">
					<i v-if="!open" class="fa fa-building"></i>
					<i v-else-if="open" class="fa fa-building-o"></i>
				</template>
				<template v-else>
					<i class="fa fa-building-o"></i>
				</template>
				{{ model ? model.name : '' }}
			</div>
		</div>
		<ul v-show="open" v-if="isFolder">
			<tree-view-employee
				class="item"
				v-for="(model, index) in model.children ? model.children : []"
				:key="index"
				:model="model">

			</tree-view-employee>
			<!--<li class="add" @click="addChild">+</li>-->
		</ul>


	</li>


</template>

<script>
	import Vue from 'vue'
	import {mapGetters, mapActions} from 'vuex'

	export default {
		name: "TreeViewEmployee",
		props: {
			model: Object
		},


		data: function () {
			return {
				open: true,
				currentPage: 1,
				perPage: 500,
			}
		},
		computed: {
			isFolder: function () {
				return this.model ? (this.model.children &&
					this.model.children.length) : ([] && 0)
			},
			...mapGetters('employees', [
				'getemployees', 'total'
			]),
		},
		methods: {
			toggle: function () {
				this.custom(this.model);
				if (this.isFolder) {
					this.open = !this.open
				}
			},
			changeType: function () {
				if (!this.isFolder) {
					Vue.set(this.model, 'children', [])
					this.addChild()
					this.open = true
				}
			},
			// addChild: function () {
			// 	this.model.children.push({
			// 		name: 'new stuff'
			// 	})
			// },
			custom(model) {
				if (model === 'undefined') {

				}
				let paramsForEmployees = {
					pageLimit: {
						page: this.currentPage,
						limit: this.perPage
					},
					id: this.model.id
				};
				this.getDepartmentByEmployeeList(paramsForEmployees);
				this.setCurrentActions(model);
			},
			...mapActions('employees', [
				'getDepartmentByEmployeeList'
			]),
			...mapActions('departments', [
				'setCurrentActions'
			]),
		},

		mounted() {
			// this.custom();
			// this.getDepartmentByEmployeeList();
		}
	}
</script>

<style scoped lang="scss">
	ul {
		padding-left: 1.7em !important;
		line-height: 1.5em;
		list-style-type: none;
	}

	#hoveredIcons {
		visibility: hidden;
		display: inline-block;
	}

	li > div {
		&:hover {
			#hoveredIcons {
				display: inline-block !important;
				visibility: visible !important;
				margin: 0;
			}
		}
	}
.notBold{
	margin: 2px 0;
}
	li div div:first-child, .add, .delete, .edit {
		display: inline-block;
		cursor: pointer;
		margin: 2px 0;
	}
	li div div:first-child {
		&:hover {
			text-decoration: underline;
		}
	}
	li div div {
		word-break: break-all;
	}
	li .bold {
		font-weight: bold;
	}
	.fa {
		margin-right: .8em;
	}
	.fa-building, .fa-building-o {
		color: #F0D45F;
	}

</style>
